if (!customElements.get('don-slider')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.don-slider-items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
        pagination: '.swiper-pagination',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);
      this.sliderInstance = false;

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
      if (FoxTheme.config.mqlMobile) {
        this.initSwiperPaginationForScrollSnap();
      }

      this.checkAndInitMobilePagination();
      window.addEventListener('resize', () => this.checkAndInitMobilePagination());

    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
        this.initScrollSnapPaginationSync(); // hanya aktifkan pagination scroll snap
        this.enableMobilePaginationStyles(true);
      } else {
         this.enableMobilePaginationStyles(false);
        this.initSlider();
      }
    }

  initSlider() {
  const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
  const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;
  let dataIndex = this.getAttribute('data-index');
  let nextBtn = this.section.querySelector(`${this.selectors.nextEl}[data-index="${dataIndex}"]`);
  let prevBtn = this.section.querySelector(`${this.selectors.prevEl}[data-index="${dataIndex}"]`);

  const sliderOptions = {
    slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems),
    spaceBetween: spaceBetween,
    navigation: {
      nextEl: nextBtn,
      prevEl: prevBtn,
    },
    pagination: {
      el: this.querySelector(this.selectors.pagination),
    },
    breakpoints: {
      1280: {
        slidesPerView: parseInt(this.items),
      },
    },
    loop: true,
    
    threshold: 2,
  };

  if (typeof this.sliderInstance !== 'object') {
    this.classList.add(this.classes.swiper);
    this.sliderWrapper.classList.remove(this.classes.grid);
    this.sliderWrapper.classList.add(this.classes.swiperWrapper);
    this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
    this.sliderInstance.init();
    
    const focusableElements = FoxTheme.a11y.getFocusableElements(this);
    focusableElements.forEach((element) => {
      element.addEventListener('focusin', () => {
        const slide = element.closest('.swiper-slide');
        this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
      });
    });
  }

  if (Shopify.designMode && typeof this.sliderInstance === 'object') {
    document.addEventListener('shopify:block:select', (e) => {
      if (e.detail.sectionId != this.sectionId) return;
      let { target } = e;
      const index = Number(target.dataset.index);
      this.sliderInstance.slider.slideToLoop(index);
    });
  }
}

 


    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }

  // ✅ Tambahan fungsi scroll-snap + bullet pagination manual
    initScrollSnapPaginationSync() {
      if (!this.sliderWrapper || !this.paginationEl) return;
      const items = this.sliderWrapper.querySelectorAll('.slider-item'); // pastikan class ini benar
      const bullets = this.paginationEl.querySelectorAll('.swiper-pagination-bullet');
      const container = this.sliderWrapper;

      const updateActiveBullet = () => {
        const scrollLeft = container.scrollLeft;
        const containerLeft = container.getBoundingClientRect().left;

        let closestIndex = 0;
        let closestOffset = Infinity;

        items.forEach((item, index) => {
          const itemLeft = item.getBoundingClientRect().left;
          const offset = Math.abs(itemLeft - containerLeft);
          if (offset < closestOffset) {
            closestOffset = offset;
            closestIndex = index;
          }
        });

        bullets.forEach((bullet, i) => {
          bullet.classList.toggle('swiper-pagination-bullet-active', i === closestIndex);
        });
      };

      container.addEventListener('scroll', updateActiveBullet);
      updateActiveBullet(); // initialize on load
    }

    // ✅ Tambahan untuk menambahkan/menghapus class pagination swiper
    enableMobilePaginationStyles(isMobile) {
      if (!this.paginationEl) return;

      if (isMobile) {
        this.paginationEl.classList.add('swiper-pagination-bullets', 'swiper-pagination-horizontal');
        this.paginationEl.style.display = '';
      } else {
        this.paginationEl.classList.remove('swiper-pagination-bullets', 'swiper-pagination-horizontal');
        this.paginationEl.style.display = 'none';
      }
    }

  }
  customElements.define('don-slider', CollectionList);
}


